import React, { createContext, useContext, useEffect, useState } from 'react';
import {
  clearAdminToken,
  getAdminToken,
  setAdminToken,
} from '../services/adminAuthStorage';
import { adminService } from '../services/adminService';
import { getApiErrorMessage } from '../utils/apiError';

const AdminAuthContext = createContext(null);

export function AdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => getAdminToken());
  const [username, setUsername] = useState(null);
  const [error, setError] = useState(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  useEffect(() => {
    const onLogout = () => {
      setToken(null);
      setUsername(null);
    };
    window.addEventListener('admin:logout', onLogout);
    return () => window.removeEventListener('admin:logout', onLogout);
  }, []);

  const login = (user, password) => {
    setIsLoggingIn(true);
    setError(null);
    return adminService
      .login(user, password)
      .then((result) => {
        setAdminToken(result.accessToken);
        setToken(result.accessToken);
        setUsername(result.admin?.username || user);
        return result;
      })
      .catch((err) => {
        const message = getApiErrorMessage(err, 'เข้าสู่ระบบไม่สำเร็จ');
        setError(message);
        return Promise.reject(err);
      })
      .finally(() => setIsLoggingIn(false));
  };

  const logout = () => {
    clearAdminToken();
    setToken(null);
    setUsername(null);
  };

  return (
    <AdminAuthContext.Provider
      value={{
        isAuthenticated: Boolean(token),
        token,
        username,
        error,
        isLoggingIn,
        login,
        logout,
        clearError: () => setError(null),
      }}
    >
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  return ctx;
}
